import { postApi } from 'api/fetchApi'
import { definitions, paths } from 'api/generated/seo'
import { NodeHeaders } from 'api/NodeHeaders'

export type SeoSearchPath = paths['/seo/search']

export const landingSearchApi = (
  searchRequest: definitions['SeoSearchPostBodyRequest'],
  headers?: NodeHeaders
) =>
  postApi<
    SeoSearchPath['post']['responses']['200']['schema'],
    SeoSearchPath['post']['parameters']['body']['body']
  >(
    '/seo/search',
    {
      ...searchRequest,
    },
    {
      headers,
    }
  )
